import VuexPersistence from "vuex-persist";
import Vue from "vue";
import axios from "axios";
import calculateItemPrice from "./mixins/calculateItemPrice";

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
});

export default {
    plugins: [vuexLocal.plugin],
    state: {
        accountId: '',
        addresses: [],
        basket: [],
        basketId: '',
        basketValues: {
            gross:  0,
            net: 0,
            shipping: 0,
            tax: 0,
            discount: 0
        },
        billingAddress: {
            building_num: '',
            street: '',
            street2: '',
            city: '',
            region: '',
            post_code: '',
            country: 'GB',
            contact_name: '',
            contact_tel: '',
            notes: '',
            streetErrors: ''
        },
        companyName: '',
        companyNumber: '',
        confirmPassword: '',
        csrf: '',
        currentProduct: {},
        currentSlug: '',
        customer: {
            email: '',
            title: '',
            firstName: '',
            lastName: '',
            telMobile: '',
            company: '',
            vat: '',
        },
        deliveryAddress: {
            building_num: '',
            street: '',
            street2: '',
            city: '',
            region: '',
            post_code: '',
            country: "GB",
            contact_name: '',
            contact_tel: '',
            notes: '',
            streetErrors: ''
        },
        discountCode: '',
        discountPercentage: '',
        discountApplied: false,
        discountShipping: 0,
        discountMsg: '',
        discountIntroducer:'',
        codeStatus: '0',
        expirationDate: '',
        emailToken: '',
        firstName: '',
        headers: '',
        invoiceAddress: '',
        jobRole: '',
        lastName: '',
        localId: '',
        loggedInToken: '',
        orderId: null,
        paymentIntent: '',
        publicKey: '',
        password: '',
        sameAddress: true,
        scrollY: 0,
        scrollYCat: 0,
        telOffice: '',
        telMobile: '',
        title: '',
        tokenExpires: '',
        vatToggle: true,
        yodahURL: '',
        shippingCalculation: '',
        freeShipping: '',
        yVersion: 4 // do not forget to update the update the function too. it should be the same number
    },
    mutations: {
        updateAccountId(state, value) {
            state.accountId = value;
        },
        updatePi(state, value) {
            state.paymentIntent = value;
        },
        updatePublicKey(state, value) {
            state.publicKey = value;
        },
        updateDeliveryAddress(state, {key, value}) {
            state.deliveryAddress[key] = value;
        },
        updateBillingAddress(state, {key, value}) {
            state.billingAddress[key] = value;
        },
        updateCustomer(state, {key, value}) {
            state.customer[key] = value;
        },
        updateOrderId(state, orderId) {
            state.orderId = orderId;
        },
        updateSameAddress(state, sameAddress) {
            state.sameAddress = sameAddress;
        },
        updateLocalId(state, value) {
            state.localId = value;
        },
        updateyVersion(state, version) {
            state.yVersion = version;
        },
        updateVatToggle(state, vatToggle) {
            state.vatToggle = vatToggle;
        },
        updateShippingCalculation(state, shippingCalculation) {
            state.shippingCalculation = shippingCalculation;
        },
        updateFreeShipping(state, freeShipping) {
            state.freeShipping = freeShipping;
        },
        updateHeaders(state, loggedInToken) {
            state.headers = {headers: {Authorization: 'Bearer ' + loggedInToken}}
        },
        updateEmail(state, email) {
            state.customer.email = email;
        },
        updateEmailToken(state, emailToken) {
            state.emailToken = emailToken;
        },
        updateTitle(state, title) {
            state.title = title;
        },
        updateLastName(state, lastName) {
            state.lastName = lastName;
        },
        updateCompanyName(state, companyName) {
            state.companyName = companyName;
        },
        updateCompanyNumber(state, companyNumber) {
            state.companyNumber = companyNumber;
        },
        updateCurrentProduct(state, currentProduct) {
            state.currentProduct = currentProduct;
        },
        updateTelOffice(state, telOffice) {
            state.telOffice = telOffice;
        },
        updateTelMobile(state, telMobile) {
            state.telMobile = telMobile;
        },
        updateJobRole(state, jobRole) {
            state.jobRole = jobRole;
        },
        updatePassword(state, password) {
            state.password = password;
        },
        updateConfirmPassword(state, password) {
            state.confirmPassword = password;
        },
        updateAddresses(state, addresses) {
            state.addresses = addresses;
        },
        updateInvoiceAddress(state, address) {
            state.invoiceAddress = address;
        },
        addItemToBasket(state, item) {
            state.basket.push(item);
        },
        addIdToBasket(state, id) {
            state.basketId = id;
        },
        removeItemFromBasket(state, index) {
            state.basket.splice(index, 1);
        },
        setDiscountCode(state, code) {
            state.discountCode = code;
        },
        setExpirationDate(state, code){
            state.expirationDate = code;
        },
        setCodeStatus(state, code){
            state.codeStatus = code;
        },
        updateDiscountMsg(state, code)
        {
            state.discountMsg = code;
        },
        updateDiscountIntroducer(state, code)
        {
            state.discountIntroducer = code;
        },
        updateDiscountAppliedStatus(state, code)
        {
            state.discountApplied = code;
        },
        setDiscountPercentage(state, code){
            state.discountPercentage = code;
        },
        setDiscountShipping(state, code){
            state.discountShipping = code;
        },
        updateBasketQuantity(state, data) {
            state.basket[data.item].quantity = data.quantity;
            state.basket[data.item].totalTax = state.basket[data.item].itemTax * data.quantity;
            state.basket[data.item].totalPrice = state.basket[data.item].itemPrice * data.quantity;
        },
        updateBasketValues(state, data) {
            Vue.set(state.basketValues, data.type, data.value );
        },
        setLocalId(state, data) {
            state.localId = data;
        },
        updateBasketItems(state, {index, key, value}) {
            state.basket[index][key] = value;
        },
        updateScrollY(state, value) {
            state.scrollY = value;
        },
        updateScrollYCat(state, value) {
            state.scrollYCat = value;
        },
        emptyBasket(state) {
            state.basket.splice(0);
            // state.basket = [];
            state.basketId = '';
            state.basketValues = {};
        },
        updateCurrentSlug(state, currentSlug) {
            currentSlug = currentSlug.split('/');
            currentSlug.shift();
            currentSlug.shift();
            currentSlug.pop();
            currentSlug = currentSlug.join('/');
            state.currentSlug = currentSlug;
        },
        logout(state) {
            state.loggedInToken = '';
            state.discountCode = '';
            state.expirationDate = '';
            state.discountApplied = false;
            state.discountPercentage = '';
            state.discountIntroducer = '';
            state.codeStatus = '0';
            state.emailToken = '';
            state.tokenExpires = '';
            state.firstName = '';
            state.lastName = '';
            state.telMobile = '';
            state.telOffice = '';
            state.companyName = '';
            state.companyNumber = '';
            state.currentProduct = {};
            state.jobRole = '';
            state.basket = [];
            state.basketId = '';
            state.basketValues = {
                    gross:  0,
                    net: 0,
                    shipping: 0,
                    tax: 0,
                    discount: 0
            };
            state.customer = {
                email: '',
                title: '',
                firstName: '',
                lastName: '',
                telMobile: '',
                company: '',
                vat: '',
            };
            state.password = '';
            state.confirmPassword = '';
            state.addresses = [];
            state.headers = '';
            state.deliveryAddress = {};
            state.invoiceAddress = {};
        },
    },
    actions: {
        // loop through basket items to check product is still published, options are correct and price is up to date
        async refreshBasket({state, dispatch, commit}){
            for (let item = state.basket.length -1; item >= 0; --item) {
                let form_data = new FormData;
                form_data.append('action', 'yodah_product_selector_query');
                form_data.append('product', state.basket[item].id);
                let product = {};
                product = await axios.post(my_ajax_object.ajax_url, form_data);
                console.log('product data', product.data.data)
                // if product is no longer published, remove from basket
                if(!product.data.data) {
                    commit('removeItemFromBasket', item);
                    //todo remove the accessories..? - should prob happen in the above function...
                } else {
                    // product data is returned, so update the products price with this info to make sure it's up to date..
                    commit('updateBasketItems', {index: item, key: 'sale_price', value: +product.data.data.sale_price});
                    commit('updateBasketItems', {index: item, key: 'shipping', value: JSON.parse(product.data.data.shipping).values});
                    commit('updateBasketItems', {index: item, key: 'sales_discounts', value: (JSON.parse(product.data.data.sales_discounts) ? JSON.parse(product.data.data.sales_discounts) : null)});
                    // if refreshed product data has options, then;
                    // 1. if selected option does not exist, delete the product
                    // 2. if selected option still exists make sure price is up to date
                    if(JSON.parse(product.data.data.options) && JSON.parse(product.data.data.options).length > 0) {
                        let refreshedProductOptions = JSON.parse(product.data.data.options).reduce((acc, cur) => {
                            acc[cur.name] = cur.values;
                            if (!cur.is_required) {
                                acc[cur.name].unshift({ value: 'Not required', price: 0 });
                            }
                            return acc;
                        }, {});
                        function convertObjectToObject(obj) {
                            const newObj = {};

                            Object.entries(obj).forEach(([key, value]) => {
                                const finishObj = {};
                                value.forEach(item => {
                                    finishObj[item.value] = item.price;
                                });
                                newObj[key] = finishObj;
                            });
                            return newObj;
                        }
                        refreshedProductOptions = convertObjectToObject(refreshedProductOptions);
                        // loop selected option to check they still exist and price is up to date
                        for (let option in state.basket[item].selectedOptions) {
                            // does the product option still exist?
                            if(refreshedProductOptions[option] !== undefined
                                && refreshedProductOptions[option][state.basket[item].selectedOptions[option].value] !== null
                                && refreshedProductOptions[option][state.basket[item].selectedOptions[option].value] !== undefined) {
                                    // update the product option price
                                    state.basket[item].selectedOptions[option].price = refreshedProductOptions[option][state.basket[item].selectedOptions[option].value];
                            }
                            else {
                                // the option no longer exists so need to remove the product...
                                // console.log('option no longer exists, removing product from basket', item);
                                commit('removeItemFromBasket', item);
                                break;
                            }
                        }
                        // todo what about if product has new option added?
                        // update the product description too...
                        if(state.basket[item] !== undefined && Object.keys(state.basket[item].selectedOptions).length > 0) {
                            let optionsDesc = '';
                            Object.keys(state.basket[item].selectedOptions).forEach((option) => {
                                optionsDesc += ' Option: ' + option + ": " + state.basket[item].selectedOptions[option].value + " £" + state.basket[item].selectedOptions[option].price + ' (included in item price).';
                            });
                            state.basket[item].desc = product.data.data.short_description + optionsDesc;
                        }
                    } else {
                        // refreshed product does not have options, but the basket product does.... - need to remove product as no longer valid
                        if(state.basket[item].selectedOptions.length > 0) {
                            commit('removeItemFromBasket', item);
                        }
                    }

                    // todo accessory prices..?
                    commit('updateShippingCalculation', product.data.data.shipping_calc);
                    commit('updateFreeShipping', product.data.data.free_shipping);
                }
            }
        },

        async calculateBasketValues({state, dispatch, commit}) {
            await dispatch('refreshBasket'); // checks products are published and have the correct values..

            // product total
            let productNetTotal = 0;
            let productTaxTotal = 0;
            for (let i = state.basket.length - 1; i >= 0; --i) {
                let data = {};
                data.product = state.basket[i];
                data.quantity = state.basket[i].quantity;
                let itemNetPrice = calculateItemPrice.methods.calculateItemPrice(data);

                productNetTotal += itemNetPrice * data.quantity;
                productTaxTotal += itemNetPrice * (state.basket[i].taxRate/100) * data.quantity;
            }

           // shipping total, includes calculation method (sum or highest) and free shipping limit
           let productGross = (productNetTotal + productTaxTotal);
           let shippingTotal = 0;
           if (!state.freeShipping || state.freeShipping > productGross) {
               Object.keys(state.basket).forEach((key) => {
                   if (state.basket[key].shipping) {
                       Object.keys(state.basket[key].shipping).forEach((rate) => {
                           if (state.basket[key].quantity >= state.basket[key].shipping[rate].from_count && (state.basket[key].shipping[rate].to_count === 0 || state.basket[key].quantity <= state.basket[key].shipping[rate].to_count)) {
                               if(state.shippingCalculation === 'sum') {
                                   shippingTotal += state.basket[key].shipping[rate].price;
                               } else if (state.shippingCalculation === 'highest') {
                                   if (shippingTotal < state.basket[key].shipping[rate].price) {
                                       shippingTotal = state.basket[key].shipping[rate].price;
                                   }
                               }
                           }
                       });
                   }
               });
           }

           commit('updateBasketValues', {type: 'shipping', value: shippingTotal});

           // net total
           let netTotal = 0;
           commit('updateBasketValues', {type: 'net', value: productNetTotal + shippingTotal});

           // tax total
           let taxTotal = 0;
           let shippingTaxTotal = shippingTotal * 0.2; //todo shipping tax should not be hard coded, needs to be in settings
           taxTotal = productTaxTotal + shippingTaxTotal;
           commit('updateBasketValues', {type: 'tax', value: taxTotal});

            // apply discount code
            await dispatch('applyDiscountCode');
            let amountToDiscount = 0;
            if(state.codeStatus === 'valid') {
                // discount is valid, include it in the basket calc
                amountToDiscount = productNetTotal + productTaxTotal;
                if(state.discountShipping) {
                    console.log('shipping included in discount')
                    amountToDiscount += shippingTotal + shippingTaxTotal;
                }
            }
            amountToDiscount = amountToDiscount * (state.discountPercentage/100);
            commit('updateBasketValues', {type: 'discount', value: amountToDiscount.toFixed(2)});
            // console.log('setDiscountedAmount ', amountToDiscount);
            //gross total
           let grossValue = productNetTotal + shippingTotal + taxTotal - amountToDiscount;
           grossValue = grossValue.toFixed(2);
           // console.log('updating gross value in basketValues...', parseFloat(grossValue));
           commit('updateBasketValues', {type: 'gross', value: parseFloat(grossValue)});

       },

        async applyDiscountCode({state, dispatch, commit}){
            let form_data = new FormData;
            form_data.append('action', 'yodah_discount_selector_query');
            form_data.append('discount', state.discountCode);
            const response = await axios.post(my_ajax_object.ajax_url, form_data)
            commit('setCodeStatus', response.data.message);
            if(response.data.message === 'valid'){
                commit('updateDiscountMsg', response.data.message);
                commit('setDiscountPercentage', response.data.discount_data.percent_discount);
                commit('setDiscountShipping', +response.data.discount_data.shipping);
                commit('updateDiscountIntroducer', response.data.discount_data.introducer);
            } else {
                commit('setDiscountPercentage', 0);
            }
            // Wait for all the commits to complete before returning
            await new Promise(resolve => setTimeout(resolve, 0));
            return true;
        },
        getAddresses({state, commit}) {
            axios.get(state.yodahURL + '/api/addresses',
                state.headers
            )
                .then(response => {
                    commit('updateAddresses', response.data);
                })
                .catch(error => {
                    console.log('there has been an error: ', error);
                })
        },
        updateLoggedInToken({commit, state}, loggedInToken) {
            state.loggedInToken = loggedInToken;
            state.tokenExpires = new Date(Date.now() + 12096e5);
            commit('updateHeaders', loggedInToken);
        },

        addItemToBasket({commit, dispatch, state}, data) {
            // console.log('addItemToBasket', data.product);
            commit('addItemToBasket', data.product);

            //todo need to add accessories..
            // data.accessories.forEach((item) => {
            //     commit('addItemToBasket', item);
            // });
            // console.log('basket after adding item...', [...state.basket]) //parentId is 0...?
            dispatch('calculateBasketValues');
            // dispatch('syncOrderWithYodah');
        },

        delItemFromBasket({commit, dispatch, state}, data) {
            // data is the index value to be deleted
            commit('removeItemFromBasket', data);

            dispatch('calculateBasketValues', "update");
            // dispatch('syncOrderWithYodah');
        },

        updateBasketQuantity({commit, dispatch, state}, data) {
            // commit('updateBasketQuantity', parentId);
            state.basket[data.index].quantity = data.quantity;
            //todo need to figure out updating accessories..
            // for (let i = state.basket.length - 1; i >= 0; --i) {
            //     if (state.basket[i]['parentId'] === data.parentId) {
            //         if (!state.basket[i]['isAccessory']) {
            //             //just update the quantity
            //             state.basket[i]['quantity'] = data.quantity;
            //         } else {
            //             // its an accessory, so need to usethe multiplier
            //             state.basket[i]['quantity'] = data.quantity * state.basket[i]['quantityPerItem'];
            //         }
            //     }
            // }
            dispatch('calculateBasketValues', "update");
            dispatch('syncOrderWithYodah');
        },
        updateBasketDeliveryAddress({commit, dispatch}, data) {
            commit('updateDeliveryAddress', data);
            dispatch('syncOrderWithYodah');
        },
        updateBasketInvoiceAddress({commit, dispatch}, data) {
            commit('updateInvoiceAddress', data);
            dispatch('syncOrderWithYodah');
        },
        // todo - need to get this working again at some point, but need Yodah endpoints setting up..
        // syncOrderWithYodah({state, commit}) {
        //     return null;
        //     if (state.basket.length > 0 && state.loggedInToken && new Date(state.tokenExpires) > new Date(Date.now())) {
        //         let order = {};
        //         order.products = [];
        //         state.basket.forEach((product) => {
        //             order.products.push({
        //                 "sku": product.sku,
        //                 "count": product.quantity,
        //                 "sales_price": product.itemPrice,
        //                 "description": product.desc
        //             });
        //         });
        //         order.delivery_address_id = (state.deliveryAddress.length > 0 ? state.deliveryAddress : null);
        //         order.billing_address_id = (state.invoiceAddress.length > 0 ? state.invoiceAddress : null);
        //         order.carriage = state.basketValues.shipping;
        //         if (state.basketId) {
        //             axios.put(state.yodahURL + '/api/orders/' + state.basketId,
        //                 order,
        //                 state.headers
        //             ).then(response => {
        //             }).catch(error => {
        //                 console.log(error)
        //             })
        //         } else {
        //             axios.post(state.yodahURL + '/api/orders',
        //                 order,
        //                 state.headers
        //             ).then(response => {
        //                 commit('addIdToBasket', response.data.data.order.id)
        //             }).catch(error => {
        //                 console.log(error.data);
        //             })
        //         }
        //     }
        // },
    },
};